import React from 'react';

import { Box } from '@mui/material';

import { Footer, withDrawerStateProvider, WithNavigationContext } from '../common';
import { useDataContext } from '../context';
import { AboutTheCompanySection } from './AboutTheCompanySection/AboutTheCompanySection';
import { AboutTheProjectSection } from './AboutTheProjectSection/AboutTheProjectSection';
import { BusinessIdeaSection } from './BusinessIdeaSection/BusinessIdeaSection';
import { MenuButton } from './components/MenuButton';
import { NavigationMenu } from './components/NavigationMenu';
import { ContactsSection } from './ContactsSection/ContactsSection';
import { FinancialProjectionsSection } from './FinancialProjectionsSection/FinancialProjectionsSection';
import { FinancingNeedsSection } from './FinancingNeedsSection/FinancingNeedsSection';
import { ImplementationPlanSection } from './ImplementationPlanSection/ImplementationPlanSection';
import { InfoSection } from './InfoSection';
import { MarketAndSalesSection } from './MarketAndSalesSection/MarketAndSalesSection';
import { ProductsAndServicedSection } from './ProductsAndServicedSection/ProductsAndServicedSection';
import { TeamSection } from './TeamSection/TeamSection';

import styles from './OnePageSecondStyle.module.scss';

export const _OnePageSecondStyle: React.FC = () => {
  const { isExtendedPreview } = useDataContext();

  return (
    <WithNavigationContext>
      <Box className={styles.pageWrapper}>
        <MenuButton />
        <NavigationMenu />
        <Box className={styles.contentWrapper}>
          <InfoSection />
          <AboutTheCompanySection />
          {isExtendedPreview && <AboutTheProjectSection />}
          {!isExtendedPreview && <BusinessIdeaSection />}
          {isExtendedPreview && <ProductsAndServicedSection />}
          <MarketAndSalesSection />
          {isExtendedPreview && <TeamSection />}
          <FinancialProjectionsSection />
          <FinancingNeedsSection />
          {isExtendedPreview && <ImplementationPlanSection />}
          <ContactsSection />
          <Footer variant="secondary" />
        </Box>
      </Box>
    </WithNavigationContext>
  );
};

export const OnePageSecondStyle = withDrawerStateProvider(_OnePageSecondStyle);
